import type { ReactedUser } from '../reactionTypes.ts';

export type ReactionAgentProfile = {
	id: string;
	name: string;
	avatarUrl?: string;
	agentIcon?: NonNullable<ReactedUser['agent']>['icon'];
	identity_account_id?: string | null;
	named_id?: string | null;
	external_config_reference?: string | null;
	isExternalAgentFallback?: boolean;
};

export type ReactionActorSource = {
	person: {
		accountId?: string | null;
		displayName?: string | null;
		profilePicture?: { path?: string | null } | null;
	};
	agentId?: string | null;
	agentType?: string | null;
};

export const mapReactionActors = (
	actors: readonly ReactionActorSource[],
	agentsById: ReadonlyMap<string, ReactionAgentProfile> | null,
	fallbackAgentName: string,
): ReactedUser[] =>
	actors.flatMap(({ person, agentId, agentType }) => {
		if (!person.accountId) {
			return [];
		}

		const agent = agentId ? agentsById?.get(agentId) : undefined;
		const user: ReactedUser = {
			id: agentId ? `${person.accountId}:${agentType ?? ''}:${agentId}` : person.accountId,
			displayName: person.displayName ?? '',
			accountId: person.accountId,
			profilePicture: person.profilePicture?.path
				? { path: person.profilePicture.path }
				: undefined,
		};

		if (agentId) {
			user.agent = {
				id: agentId,
				name: agent?.name ?? fallbackAgentName,
				avatarUrl: agent?.avatarUrl,
				icon: agent?.agentIcon,
				identityAccountId: agent?.identity_account_id ?? undefined,
				profileId: agent && !agent.isExternalAgentFallback ? agent.id : undefined,
				namedId: agent?.external_config_reference ?? agent?.named_id ?? undefined,
			};
		}

		return [user];
	});
